import { createStore } from 'vuex'

export default createStore({
  state: {
    token: undefined
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
